import {typesINPUT} from '../redux/svtypes/inputTypes'

let initStore = {
    loading: false,
    error: false,
    radio_data: [
        {
            "name": "1",
            "id": 1,
            "selected": true,
            "age": 23,
            "species": "T. Rex"
        },
        {
            "name": "2",
            "id": 2,
            "selected": false,
            "age": 44,
            "species": "Bracchio"
        },
        {
            "name": "3",
            "id": 3,
            "selected": false,
            "age": 32,
            "species": "Stego"
        },
        {
            "name": "4",
            "id": 4,
            "selected": false,
            "age": 13,
            "species": "T. Rex"
        }
    ],
    my_data: [
        {
            "name": "Bob",
            "age": 23,
            "species": "T. Rex"
        },
        {
            "name": "Dylan",
            "age": 44,
            "species": "Bracchio"
        },
        {
            "name": "Kate",
            "age": 32,
            "species": "Stego"
        },
        {
            "name": "Sally",
            "age": 13,
            "species": "T. Rex"
        }
    ]
}

export default (state = initStore, action) => {
    console.log(action);
    let januState;
    switch (action.type) {
        case "dino-success":
            console.log("dinos success");
            console.log(action.payload.my_data);
            // let januState = {...state, loading: false, my_data: action.payload.my_data}
             januState = {...state, loading: false, my_data: action.payload.my_data}
            return januState
        case "radio-success":
                console.log("radio success");
                console.log(action.payload.my_data);
                // let januState = {...state, loading: false, my_data: action.payload.my_data}
                 januState = {...state, loading: false, radio_data: action.payload.radio_data}
                return januState
        case typesINPUT.GET_MY_DATA_BEGIN:
            console.log("loading")
            return {...state, loading: true}
        case typesINPUT.GET_MY_DATA_Error:
            console.log("error")
            return {...state, error: true}
    }
}